import React from "react";
import * as Scrivito from "scrivito";
import { ExpandCollapseLevels } from "components/ProjectTree/ExpandCollapseLevels";
import { useProjectDataStore } from "stores/projectStore";
import { VirtualizedProject } from "objs/_ConfiguratorObjs/ProjectItem/SubComponents/ProjectTreeList/VirtualizedProject";

export const ProjectTreeList = Scrivito.connect(() => {
  const projectName = useProjectDataStore((state) => state.projectName);
  return (
    <div className="text-gray-700 pt-2">
      <div className="w-100 d-flex flex-column justify-content-between align-items-start border-bottom border-dark border-2 py-2 gap-2_5">
        <div className="fw-bolder fs-md">{projectName}</div>
        <div className="d-flex flex-nowrap">
          <ExpandCollapseLevels />
        </div>
      </div>
      <div className="w-100">
        <VirtualizedProject />
      </div>
    </div>
  );
});
